import { useState, useEffect } from 'react';

/**
 * a Util function that will convert the absolute width into breakpoints
 */
const getBreakPoint = (windowWidth: number) => {
  if (windowWidth) {
    if (windowWidth < 550) { return 'sm'; }
    if (windowWidth < 850) { return 'md'; }
    if (windowWidth < 1150) { return 'lg'; }
    return 'xl';
  }
  return undefined;
};

/**
 * Custom Hook which returns updated screen size in string format of: sm, md, lg, or xl
 */
const useWindowSize = () => {
  const isWindowClient = typeof window === 'object';

  const [windowSize, setWindowSize] = useState(
    isWindowClient ? getBreakPoint(window.innerWidth) : undefined
  );

  useEffect(() => { // eslint-disable-line consistent-return
    // a handler which will be called on change of the screen resize
    function setSize() {
      setWindowSize(getBreakPoint(window.innerWidth));
    }

    if (isWindowClient) {
      // register the window resize listener
      window.addEventListener('resize', setSize);

      // unregister the listener on destroy of the hook
      return () => window.removeEventListener('resize', setSize);
    }
  }, [isWindowClient, setWindowSize]);

  return windowSize;
};

export default useWindowSize;
